/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CardAction } from './CardAction';

const Card = (
  {
    children,
    component,
    href,
    onClick,
  }) => {

  const isActionable = href || onClick;

  const cardClasses = classNames(
    'sui-flex sui-bg-primary sui-rounded-base sui-border-solid sui-border-primary sui-border-1'
  );

  const CardRoot = component;
  const CardContentRoot = isActionable ? CardAction : 'div';

  const rootProps = {
    href,
    onClick
  };

  return (
    <CardRoot className={cardClasses}>
      <CardContentRoot className="sui-flex sui-w-full sui-text-left sui-rounded-base sui-flex-col sui-gap-4 hover:sui-no-underline sui-p-4 sui-overflow-hidden" {...rootProps}>
        {children}
      </CardContentRoot>
    </CardRoot>
  );
};

Card.displayName = 'Card';

Card.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Allows to change the rendered div for a semantic element
   * @default div
   */
  component: PropTypes.oneOf(['div', 'article', 'section']),
  /**
   * Provide an URL when the Card should render its content as a link using an 'a' tag
   */
  href: PropTypes.string,
  /**
   * Provide the `onClick` event handler when the Card should render its content as a button using an 'button' tag
   */
  onClick: PropTypes.func,
};

Card.defaultProps = {
  component: 'div'
};

export { Card };